const data = {
  facebook: "https://facebook.com/tanvir.mahin.1",
  twitter: "https://leetcode.com/tanvirmahin24/",
  linkedin: "https://www.linkedin.com/in/tanvirmahin24/",
  email: "tanvirmahin24@gmail.com",
  github: "https://github.com/TanvirMahin24",
};

export default data;
